export default {
  brandDesc:
    "Orange County's premier food truck consulting agency. We help operators navigate permits, regulations, and growth strategies.",
  address: "Santa Ana, Orange County, CA",
  officeHours: "Office Hours",
  hours: [
    { day: "Monday – Friday", hours: "7:00 AM – 7:00 PM" },
    { day: "Saturday", hours: "By Appointment Only" },
    { day: "Sunday", hours: "Closed" },
  ],
  quickLinks: "Quick Links",
  quickServices: "Services",
  quickHowToOperate: "How to Operate",
  quickRegulations: "Regulations & Permits",
  quickBookSession: "Book a Session",
  bookSession: "Book a Session",
  copyright: "My Food Truck Agency. All rights reserved.",
  serving: "Serving Orange County, CA since 2025",
};